import { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery
} from '@mui/material';
import moment from 'moment';
import {
  CmpButtonWithIcon,
  CmpSelectArrField,
  CmpTypographyField
} from '../../../component/ToolBox/ToolBox';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { Refresh } from '@mui/icons-material';
import {
  getStock_Transfer_Distribution_Summary,
  Stock_Transfer_Distribution_Summary
} from '../actions';
import StockTransferDistributionBreadCrumbs from '../ProcessComponents/StockTransferDistributionBreadCrumbs';
import { StockTransferModalComp } from '../ProcessComponents/StockTransferModalComp';
import { getStatusStyleV1 } from '../../../Utility/Utilitys';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';

const toolbar = {
  backgroundColor: '#0d73bb',
  color: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '40px !important'
};

export default function StockTransferDistributionSummary() {
  const statusData = ['ALL', 'ENTER', 'POST'];
  const [sStatus, setStatus] = useState('ALL');
  const rdxFilterObj = useSelector((state) => state.layoutSlice.filter);
  const locList = useSelector((state) => state.SliceDB.value.getLocation);
  const dcLoclist = useSelector((state) => state.SliceDB.value.getDCLocation);

  const vMediaQuery = useMediaQuery('(max-width: 900px)');

  const [sFilteredLocNames, setFilteredLocNames] = useState([]);
  const rdxUser = useSelector((state) => state.SliceDB.value);
  const [sFilteredDCNames, setFilteredDCNames] = useState([]);
  const [sDetail, setDetail] = useState([]);
  const [selectedDetailData, setSelectedDetailData] = useState({});
  const [purchaseStockTransferModal, setPurchaseStockTransferModal] = useState(false);

  const fSummary = async () => {
    const obj = {
      FromDt: moment(rdxFilterObj.dateFrom).format('MM/DD/YYYY'),
      ToDt: moment(rdxFilterObj.dateTo).format('MM/DD/YYYY'),
      Status: sStatus,
      UserCd: rdxUser.login.userId
    };
    const result = await Stock_Transfer_Distribution_Summary(obj);
    if (result.Type == 'Success') {
      setDetail(result.ResultSet);
    } else {
      setDetail([]);
    }
    return result.ResultSet;
  };

  const fOnPageLoad = useCallback(async () => {
    let filteredDC = dcLoclist.filter((i) => rdxFilterObj.DCList.includes(i.UId));
    setFilteredDCNames(filteredDC.map((i) => i.Name1));
    let filteredLoc = locList.filter((i) => rdxFilterObj.locList.includes(i.UId));
    setFilteredLocNames(filteredLoc.map((i) => i.Name1));
    await fSummary();
  }, [rdxFilterObj, locList, dcLoclist]);

  const fOnpressLoad = async () => {
    await fSummary();
  };
  useEffect(() => {
    fOnPageLoad();
  }, [fOnPageLoad]);

  const fOnRowClick = (row) => {
    setPurchaseStockTransferModal(true);
    setSelectedDetailData(row);
  };

  const gridColumns = [
    {
      field: 'A_TransId',
      headerName: 'Trans.ID',
      flex: 0.8,
      minWidth: 100
    },
    {
      field: 'A_TransDt',
      headerName: 'Date',
      flex: 0.7,
      minWidth: 100,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ({ value }) => moment(value).format('DD/MM/YYYY')
    },
    {
      field: 'A_VocNo',
      headerName: 'Ref.Doc.No',
      flex: 1,
      minWidth: 120,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'DCLocName',
      headerName: 'From.Loc',
      flex: 1,
      minWidth: 130
    },
    {
      field: 'ToLocName',
      headerName: 'To.Loc',
      flex: 1,
      minWidth: 130
    },
    {
      field: 'Department',
      headerName: 'Department',
      flex: 1,
      minWidth: 130
    },
    {
      field: 'Truck',
      headerName: 'Truck',
      flex: 0.8,
      minWidth: 100
    },
    {
      field: 'A_Status',
      headerName: 'Status',
      flex: 0.6,
      minWidth: 100,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const val = params.value === true ? 'POST' : 'ENTER';
        const style = getStatusStyleV1(val);
        return (
          <div
            style={{
              ...style,
              padding: '2px 8px',
              borderRadius: '4px',
              textAlign: 'center',
              width: '100%',
              fontWeight: 'bold'
            }}>
            {val}
          </div>
        );
      }
    }
  ];

  return (
    <div className="container">
      <StockTransferDistributionBreadCrumbs />
      <Grid container spacing={1} className="mb-2">
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            spacing={1}
            // columns={{ xs: 12, sm: 12, md: 12 }}
            sx={{ alignItems: 'center' }}>
            <Grid item xs={2.7} sm={2.5} md={1.5}>
              <CmpTypographyField xcomponent={'span'} xText={'Branch'} />
            </Grid>
            <Grid item xs={1} sm={0.5} md={0.3}>
              <CmpTypographyField xcomponent={'span'} xText={':'} />
            </Grid>
            <Grid
              item
              xs={8.3}
              sm={9}
              md={10.2}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
              <Typography component="span">{sFilteredLocNames.toString()}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            sx={{ alignItems: 'center' }}>
            <Grid item xs={2.7} sm={2.5} md={3}>
              <CmpTypographyField xcomponent={'span'} xText={'Distributing Location'} />
            </Grid>
            <Grid item xs={1} sm={0.5} md={0.6}>
              <CmpTypographyField xcomponent={'span'} xText={':'} />
            </Grid>

            <Grid item xs={8.3} sm={8} md={8.4}>
              <CmpTypographyField xcomponent={'span'} xText={sFilteredDCNames.toString()} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            sx={{ alignItems: 'center' }}>
            <Grid item xs={5.5} sm={5.05} md={4.6}>
              <CmpTypographyField xcomponent={'span'} xText={'From Date'} />
            </Grid>
            <Grid item xs={2} sm={1} md={1}>
              <CmpTypographyField xcomponent={'span'} xText={':'} />
            </Grid>
            <Grid item xs={4.5} sm={5.95} md={6.4}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={moment(rdxFilterObj.dateFrom).format('DD/MM/YYYY')}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            sx={{ alignItems: 'center' }}>
            <Grid item xs={5} sm={4} md={4}>
              <CmpTypographyField xcomponent={'span'} xText={'To Date'} />
            </Grid>
            <Grid item xs={2} sm={1} md={1}>
              <CmpTypographyField xcomponent={'span'} xText={':'} />
            </Grid>
            <Grid item xs={4.5} sm={7} md={7}>
              <CmpTypographyField
                xcomponent={'span'}
                xText={moment(rdxFilterObj.dateTo).format('DD/MM/YYYY')}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={10} md={6}>
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            sx={{ alignItems: 'center' }}>
            <Grid item xs={2.7} sm={3} md={3}>
              <CmpTypographyField xcomponent={'span'} xText={'Status'} />
            </Grid>
            <Grid item xs={1} sm={0.6} md={0.6}>
              <CmpTypographyField xcomponent={'span'} xText={':'} />
            </Grid>
            <Grid item xs={8.3} sm={7.5} md={8.4}>
              <CmpSelectArrField
                xLabelText="Status"
                xValue={sStatus}
                xOnChange={(event) => setStatus(event.target.value)}
                xName={'Status'}
                xData={statusData}
                xValueMember={''}
                xDispalyMember={''}
                xError={false}
                xErrorMessage={false}
                xDisable={false}
                xTabIndex={'2'}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={2} md={6}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            sx={{
              display: 'flex',
              justifyContent: vMediaQuery ? 'center' : 'end',
              alignItems: 'center'
            }}>
            <Grid
              item
              xs={3}
              sm={12}
              md={2.5}
              sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <CmpButtonWithIcon
                xvariant={'contained'}
                xsize={'small'}
                xonClick={() => fOnpressLoad()}
                xLabel={'Load'}
                xIcon={<Refresh />}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box
        sx={{
          height: '65vh'
        }}>
        <DataGridPro
          rows={sDetail}
          getRowId={(row) => row.A_TransId}
          columns={gridColumns}
          rowHeight={35}
          headerHeight={35}
          hideFooter
          sx={{
            borderColor: 'primary.light',
            border: 1,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#0d73bb',
              color: 'white'
            }
          }}
          componentsProps={{
            filterPanel: { sx: { maxWidth: '93vw' } }
          }}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'mui-even-row' : 'mui-odd-row'
          }
          onRowDoubleClick={(params) => fOnRowClick(params.row)}
        />
      </Box>
      <StockTransferModalComp
        open={purchaseStockTransferModal}
        onClose={() => setPurchaseStockTransferModal(false)}
        headObj={selectedDetailData}
        xMediaQuery={vMediaQuery}
        fOnPageLoad={fOnPageLoad}
        setSelectedDetailData={setSelectedDetailData}
      />
    </div>
  );
}
